import BubbleAndLine from "./components/BubbleAndLine";
import Graph2 from "./components/Graph2";
import ResultScreen from "./containers/ResultScreen";
import './App.css';
import { useEffect, useState } from "react";
import RotateModal from "./components/RotateModal"
import { withOrientationChange } from "react-device-detect";

function App(props) {
  const [qIndex, setQIndex] = useState(0)
  const [currentScreen, setCurrentScreen] = useState("Quiz");

  const { isPortrait, isLandscape, } = props;
  console.log("props: ", props);
  const [openPopup, setOpenPopup] = useState(true);

  const handleReloadClick = () => {
    // Update the qIndex state to trigger a re-render of the BubbleAndLine component
    setQIndex((prevQIndex) => prevQIndex + 1);
  };
  console.log("isPortrait", isPortrait)
  console.log("isLandscape", isLandscape)
  return (
    <div className="App">
       { !isPortrait &&
       <>
        { currentScreen === "Quiz" ?
            qIndex === 0 ? <BubbleAndLine qIndex={qIndex} handleReloadClick={handleReloadClick}/>
            : <Graph2 qIndex={qIndex} setCurrentScreen={setCurrentScreen}/>
        : <ResultScreen  setCurrentScreen={setCurrentScreen} setQIndex={setQIndex}/>
        }
      </>
      }
      <RotateModal
        isOpen={isPortrait}
      />
    </div>
  );
}

export default withOrientationChange(App);
